import styled from '@emotion/styled';

const Artist = styled('div')(({ theme }) => ({
  color: theme.colors.gray.medium,
  display: 'inline-block',
  fontSize: theme.fonts.size['13'],
  letterSpacing: '0.2rem',
  width: 'calc(50% - 16.6rem)',
}));

export default Artist;
